// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"13":"dec4404635b3d21a68cb","320":"35a7f44c4bf8f967c1d4","505":"45613f33e2ec38046735","540":"392251c995152e4968d8","855":"8af86a8daf0e963e671d"}[chunkId] + ".bundle.js";
};